module.exports = __webpack_public_path__ + "img/588x310-02.9d575fca.png";